module.exports = __webpack_public_path__ + "img/dcp.5b852555.svg";